<template>
  <section class="bg-amber-100 py-20 sm:py-20 md:py-28 lg:py-32 xl:py-36">
    <Swiper
      :slides-per-view="1"
      :space-between="50"
      @swiper="onSwiper"
      @reach-beginning="reachedBeginningOrEnd('beginning')"
      @reach-end="reachedBeginningOrEnd('end')"
      @from-edge=";(reachBeginning = false), (reachEnd = false)"
      @active-index-change="onSlideChange($event)"
    >
      <SwiperSlide v-for="(slide, index) in data.slides" :key="index">
        <div class="md:px-10 lg:px-24">
          <div class="relative mx-auto max-w-screen-2xl">
            <!-- IMAGE -->
            <div
              class="aspect-4/3 w-full overflow-hidden rounded-lg lg:w-9/12 2xl:w-7/12"
              :class="{
                'ml-auto': slide?.positioning?.value == 'imageIsRight',
              }"
            >
              <AppImage
                v-if="slide.image"
                loading="lazy"
                :src="slide.image"
                class="h-full w-full object-cover"
              />
            </div>
            <!-- BTN AND TEXT CONTAINER -->
            <div
              class="relative bottom-0 z-40 -mt-16 flex w-11/12 max-w-3xl flex-col-reverse lg:-mt-52 lg:block xl:absolute xl:w-full"
              :class="{
                'ml-auto right-0': slide?.positioning?.value !== 'imageIsRight',
              }"
            >
              <div
                class="mb-8 mt-4 flex space-x-4 lg:mx-5"
                :class="
                  slide?.positioning?.value === 'imageIsRight'
                    ? 'justify-end md:justify-start'
                    : 'justify-start md:justify-end'
                "
              >
                <!-- ARROWS -->
                <SliderButtons
                  :reach-beginning="reachBeginning"
                  :reach-end="reachEnd"
                  :tabindex="index === activeIndex ? '0' : '-1'"
                  @prev="swiper.slidePrev()"
                  @next="swiper.slideNext()"
                />
              </div>
              <!-- TEXT -->
              <div
                class="max-w-3xl rounded-lg bg-blue-500 py-6 pl-6 pr-8 text-white blue:bg-blue-500 green:bg-green-500 pink:bg-pink-500 sm:px-14 sm:py-10"
              >
                <h2
                  class="mb-5 max-w-md text-[1.875rem] font-medium leading-[1.2] md:mb-8 md:text-4xl"
                >
                  {{ slide.heading }}
                </h2>
                <div
                  class="text mb-10 text-sm leading-snug tracking-tight !text-white md:text-base md:leading-normal"
                  v-html="slide.content"
                />
                <AppLink
                  v-if="slide.link"
                  :to="slide.link"
                  class="slider-link-color-white slider-link-ring-white -m-1 p-1 text-xs md:text-sm"
                >
                  {{ slide.link_text }}
                </AppLink>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  </section>
</template>

<script setup>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'

// Import Swiper styles
import 'swiper/css'

const props = defineProps({
  data: { type: Object, required: true },
})

let swiper = {}

let reachBeginning = ref(true)
let reachEnd = ref(false)
let activeIndex = ref(0)

const onSwiper = (swiperElement) => {
  swiper = swiperElement
}

const onSlideChange = (event) => {
  activeIndex.value = event.activeIndex
}
async function reachedBeginningOrEnd(beginningOrEnd) {
  // need to wait until from edge event has set its values
  await nextTick()

  if (beginningOrEnd === 'beginning') {
    reachBeginning = true
  } else {
    reachEnd = true
  }
}
</script>

<style scoped lang="scss">
.swiper-slide:first-child {
  .arrowBtnBack {
    @apply opacity-25;
  }
}
.swiper-slide:last-child {
  .arrowBtnNext {
    @apply opacity-25;
  }
}
</style>

<style lang="scss">
.slider-link-color-white span {
  color: white !important;
}
.slider-link-ring-white span {
  @apply ring-white #{!important};
}
</style>
